import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import useFetch from '../hooks/useFetch'
import {Apis} from '../util/Apis'
import Anfora from '../components/templates/anforaTemplate'
import NoElements from '../components/generales/noElements'
import CustomCard from '../components/generales/card'

import anfora from '../components/icons/anfora.svg'
import {Loading} from '../components/blocks'

const IconAnfora = styled.div`
  width: 24px;
  height: 25px;
  background-color: #000;
  -webkit-mask: url(${anfora}) no-repeat center;
  mask: url(${anfora}) no-repeat center;
`

const Anforas = () => {

  const salaInfo = JSON.parse(localStorage.getItem('salaInfo'))

  const {data, loading} = useFetch(Apis.CAPP + '/anforas?salaId=' + salaInfo.salaId)

  const [anforasDisponibles, setAnforasDisponibles] = useState([])

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setAnforasDisponibles(data)
    }
  }, [data])

  return (
    <>
      {loading ?
        <Loading />
        :
        <div fluid style={{marginTop: '-4rem', padding: '0 1rem'}}>
          <CustomCard titulo='Ánfora'
            subtitulo='lista de ánforas disponibles'
            icono={<IconAnfora style={{marginRight: '4px'}} />}
            detalle={<span> <strong>{anforasDisponibles.length}</strong> ánfora(s) disponible(s)</span>}
          />
          {anforasDisponibles.length > 0 ?
            <>
              {anforasDisponibles.map((item, i) =>
                <Anfora key={i} nombre={item.name} depositados={item.quantity} disponibles={item.couponsAvailable}
                  id={item.id} anforaColor={item.couponTypeColor} />
              )}
            </>
            :
            <NoElements titulo='No hay ánforas disponibles en este momento'
              subtitulo='Vuelva a intentarlo más tarde' />
          }
        </div>
      }
    </>
  )
}


export default Anforas
